import React, { useState } from 'react';
import { Button, CloseButton } from '@chakra-ui/react';
import { DownloadIcon } from '../../../Assets/images/svgs';
import "./style.css";

const ImageViewer = ({btnName="View", btnClassName, imgUrl, isDownloadable, downloadBtn="Download", downloadBtnClassName, downloadedImgName='image'}) => {
  const [showModal, setShowModal] = useState(false)

  const downloadImage = async () => {
    try {
      // Fetch the image data
      const response = await fetch(imgUrl);
      const blob = await response.blob();

      // Create a URL object for the blob
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = downloadedImgName;

      a.click();
    } catch (error) {
      console.error("Something went wrong : Invalid Image path");
    }
  };
  return (
    <>
      { showModal ? 
        (
          <div className="image-modal-container">
            <div className='modal-header'>
              {isDownloadable ? <Button className={`img-download-btn ${downloadBtnClassName}`} onClick={downloadImage} leftIcon={<DownloadIcon />} colorScheme='blue' variant='solid' fontSize={14}>
                {downloadBtn}
              </Button> : <span></span>}
              <CloseButton className='modal-close-icon' onClick={() => setShowModal(!showModal)} />
            </div>
            <div className="image-modal">
              <img src={imgUrl} alt="" />
            </div>
          </div> 
        )
        : <p className={`modal-active-btn ${btnClassName}`} onClick={() => setShowModal(!showModal)}>{btnName}</p>
      }
    </>
  )
}

export default ImageViewer
